import React,{Component} from 'react';
import {connect} from 'react-redux';
import * as f2 from './store/actions';

class Form2 extends Component
{	
	
	input(e)
	{
		this.props.input(e.target.name,e.target.value)
	}
	update(e)
	{
		e.preventDefault()
		this.props.update()
	}
	render()
	{

		let {id,name,email}=this.props.ob
		if(id>0)
		{
			return (
					<div>
						<h1>edit student {id}</h1>
						<form onSubmit={this.update.bind(this)}>
							<input onChange={this.input.bind(this)} name="name" value={name} placeholder="name" />
							<input onChange={this.input.bind(this)} name="email" value={email} placeholder="email" />
							<button>update</button>
						</form>
					</div>
				)
		}
		else
		{
			return null
		}
	}
}

export default connect(state=>state,f2)(Form2);